import axiosInstance from "./AxiosInstance";
import config from "../config";

export const searchRepresentative = (query) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.searchRepresentative,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      input: query,
    },
  });
};
export const listProfessional = (businessId) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.getRequestedProfessionalList(businessId),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const listAssignedProfessional = (businessId) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.getAssignedProfessionalList(businessId),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const assignProfessional = (businessId, professionalId, profession) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: `business/${businessId}/assignprofessional/${professionalId}`,
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: { profession: profession },
  });
};
export const requestForRepresentative = (businessId, repId) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: `representative/request/${businessId}/${repId}`,
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const assignedRepToBusinessService = (businessId) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: `requested-representative/${businessId}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const cancelRepRequestService = (businessID, repId) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: `cancle-request/${businessID}/${repId}`,
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const assignRepresentativeToBusiness = (businessId, rid) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.assignRepresentative(businessId, rid),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const reAssignRepresentativeToBusiness = (businessId, rid) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.reAssignRepresentative(businessId, rid),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAssignBusiness = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.getAssignBusiness,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getRepresentativeStatus = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.getRepStatus(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const changeStatusService = (id, status) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.getRepStatus(id),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { status: status },
  });
};
export const getRequestednBusiness = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: "business/requested",
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchAllRepresentatives = (page, size) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.fetchRepresentativesApi,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page,
      size,
    },
  });
};
export const fetchAllAdministrators = (page, size) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.fetchAdministratrosApi,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page,
      size,
    },
  });
};

export const fetchSellerDetails = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.sellerProfile(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteSellerProfile = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.sellerProfile(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addSellerProfile = (data, id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url:
      id !== null
        ? config.routes.sellerProfile(id)
        : config.routes.sellerProfileCreate,
    method: id !== null ? "put" : "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      address: data?.address,
      city: data?.city,
      contactemail: data?.contactEmail,
      contactname: data?.contactName,
      country: data?.country,
      domain: data?.domain,
      email: data?.email,
      fax: data?.fax,
      name: data?.name,
      occupation: data?.occupation,
      phone: data?.phone,
      phone2: data?.phone2,
      postalcode: data?.postalCode,
      region: data?.region,
      website: data?.website,
    },
  });
};
